import type { FunctionComponent } from 'react'
import React from 'react'
import { Author, Picture, TypographyV2 as Typography } from '@which/seatbelt'

import classnames from 'classnames'

import type { ArticleCTAProps } from '../../types/toolTypes'
import styles from './ArticleCTA.module.scss'

export const ArticleCTA: FunctionComponent<ArticleCTAProps> = ({
  author,
  className,
  handleSubmit,
  headline,
  image,
  link,
  title,
}) => {
  return (
    <div>
      <a
        className={classnames(styles.articleCta, className)}
        data-testid="article-cta"
        href={link.href}
        onClick={handleSubmit}
      >
        <div className={styles.ctaText}>
          <Typography className={styles.articleCtaTitle} tag="h2" textStyle="sb-text-heading-small">
            <span className={styles.articleCtalineAnimation}>{title}</span>
          </Typography>
          <Typography
            className={styles.articleCtaDescription}
            tag="p"
            textStyle="sb-text-body-default-regular"
          >
            {headline}
          </Typography>
          {author && <Author {...author} />}
        </div>
        <div className={styles.articleCtaPicture}>
          {image && (
            <Picture {...image} imageClassName={styles.articleCtaImageClassName} lazyLoad={false} />
          )}
        </div>
      </a>
    </div>
  )
}
